import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import Label from '../Label'
import { parseEnumLabel } from 'src/util/helpers'

const Style: React.FC = () => {
    const { productData } = useBrewDetailStore()
    const [showToolTip, setShowToolTip] = React.useState(false)
    const styleTitle =
        productData?.styleAlias ||
        productData?.style?.title ||
        productData?.kombuchaFamily ||
        productData?.ciderFamily ||
        productData?.__typename ||
        '--'

    const styleDescription = productData?.style?.description || '--'
    const descriptionText =
        styleDescription.length > 250
            ? `${styleDescription.substring(0, 250)}...`
            : styleDescription

    const displayTitle = parseEnumLabel(styleTitle)
    const isBeer = productData?.__typename === 'Beer'
    const isKombucha = productData?.__typename === 'Kombucha'
    const isCider = productData?.__typename === 'Cider'

    const parseStyleLabel = (label: string) => {
        switch (label) {
            case 'Beer':
                return 'Brew Style'
            case 'Kombucha':
                return 'Kombucha Family'
            case 'Cider':
                return 'Cider Family'
            default:
                return 'Style'
        }
    }

    return (
        <>
            <div className='relative flex items-center gap-1'>
                <Label labelText={parseStyleLabel(productData?.__typename)} />
                {productData?.__typename === 'Beer' && (
                    <>
                        <UI.Icon
                            slug='HeroIcons.InformationCircle'
                            size='sm'
                            customClasses='hover:text-black cursor-pointer text-medium'
                            onClick={() => setShowToolTip(true)}
                        />
                        <div className='absolute bottom-5 left-full md:left-[92%]'>
                            <UI.Tooltip
                                label={displayTitle}
                                description={descriptionText}
                                theme='light'
                                action='click'
                                isOpen={showToolTip}
                                onClose={() => setShowToolTip(false)}
                                position='top'
                                customClasses='bg-white'
                            />
                        </div>
                    </>
                )}
            </div>
            <span className='text-lg font-bold text-dark'>{displayTitle}</span>
        </>
    )
}

export default Style
